export class User {
  Id: number;
  FirstName: string | undefined;
  LastName: string | undefined;
  Username: string | undefined;
  Nickname: string | undefined;
  Type: number | undefined;
}

export enum UserType {
    Client = 1, Recruiter, Admin
}



// WEBPACK FOOTER //
// ./src/app/models/User.model.ts